import {eventHandler, findID} from "../../../../../../../modules/vegas/js/util";

class VGCartPromocode {
	setCartPromocode(code, data) {
		let cartForm = document.querySelector('.cart-form');
		let input = cartForm.querySelector('[name=promocode]');

		input.value = code;
		eventHandler.on(input, 'change');

		cartForm.querySelector('.promocode[data-status="0"]').classList.add('d-none');

		let p = document.querySelector('.cart-form .promocode[data-status="1"]');
		p.querySelector('.percent').innerHTML = data.percent;
		p.querySelector('.code').innerHTML = code;
		p.classList.remove('d-none');
	}

	clearCartPromocode() {
		let cartForm = document.querySelector('.cart-form');
		let input = cartForm.querySelector('[name=promocode]');

		input.value = '';
		eventHandler.on(input, 'change');

		cartForm.querySelector('.promocode[data-status="0"]').classList.remove('d-none');
		cartForm.querySelector('.promocode[data-status="1"]').classList.add('d-none');
	}

	setModalResult(code, data) {
		let percent = data.percent;

		let modal = findID('modal-promocode');
		let msg;

		if (data.error) {
			msg = modal.querySelector('.msg.msg-error');
			msg.innerHTML = data.msg;
		} else {
			msg = modal.querySelector('.msg.msg-success');
			msg.innerHTML = `Промокод активирован, скидка: ${percent}%`

			this.setCartPromocode(
				code, data
			)
		}

		msg.classList.remove('d-none');
	}

	clearModalResult() {
		findID('modal-promocode').querySelectorAll('.msg').forEach((el) => {
			el.classList.add('d-none')
		});
	}

	clearModalPromocode() {
		findID('modal-promocode').querySelector('[name=code]').value = '';
	}
}

export default VGCartPromocode
